module.exports = __webpack_public_path__ + "static/media/s.9d46a078.png";